//@import dependencies
import React, {useState, useEffect, useMemo} from 'react'
import { useTranslation } from 'react-i18next'
import { IconContext } from "react-icons";
import { MdEmail, MdShare } from "react-icons/md";
import { AiOutlineHeart, AiOutlineInfoCircle } from "react-icons/ai";
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { customs } from 'app_config/globals';
import moment from 'moment'
import {FacebookShareButton, TwitterShareButton, LinkedinShareButton, EmailShareButton, WhatsappShareButton} from 'react-share'
import {FaFacebookF, FaTwitter, FaLinkedinIn, FaLink, FaWhatsapp} from 'react-icons/fa'
import {BsPlay} from 'react-icons/bs'
//@end

//@import components
// import StarsComponentCommon from 'app_components/commons/stars'
import ModalMediaComponent from 'app_components/commons/modalMedia'
//@end
//@end

// @import hooks
// @end

// @import types
import {ICourse} from 'app_types/campus/academic/courseTypes'
// @end

// @INFO Import services
import DurationFieldService from 'app_services/components/durationFieldService'
// import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../offercardCommon.scss'
import { Link } from 'react-router-dom';
import { CourseSchedulingCourseType } from 'app_types/admin/courseScheduling/courseSchedulingTypes';
import FreeTag from 'app_components/commons/FreeTag/FreeTag';
// import { routingService } from 'app_services/routingService';

// @ADD Component types
interface IOffercardCommonLayoutProps {
	course: ICourse
  list?: boolean
  link?: string
  share?: string
  hidePrice?: boolean
  hideValidUntil?: boolean
  hideTaxesText?: boolean
  hideInfoIcon?: boolean
}

const OffercardCommonLayout: React.FC<IOffercardCommonLayoutProps> = (props) => {

  const durationFieldService: DurationFieldService = new DurationFieldService()

  const { t } = useTranslation()
  const { course } = props

  const [openModal, updateOpenModal] = useState<boolean>(false)
  const [triggerClose, updateTriggerClose] = useState<any>({})

  const isFree = useMemo(() => course?.typeCourse === CourseSchedulingCourseType.FREE || course?.typeCourse === CourseSchedulingCourseType.MOOC, [course?.typeCourse])

  const getPrice = (withDiscount: boolean = true) => {
    const price = course?.priceCOP
    const discount = course?.discount
    let finalPrice = ''
    if(!price) return null

    let priceWithIva = parseFloat(price.toString())
    if (customs?.iva) {
      priceWithIva = priceWithIva + ((priceWithIva * parseInt(customs?.iva)) / 100)
    }

    if (withDiscount === true && moment().isSameOrBefore(moment(course?.endDiscountDate).endOf('day'))) {
      if(discount){
        finalPrice += parseFloat(Math.round(priceWithIva*(1-(discount/100))).toString()).toLocaleString('es-CO', {style: 'currency', currency: 'COP'}).replace(',00', '')
      }else{
        finalPrice += priceWithIva.toLocaleString('es-CO', {style: 'currency', currency: 'COP'}).replace(',00', '')
      }
    } else {
      finalPrice += priceWithIva.toLocaleString('es-CO', {style: 'currency', currency: 'COP'}).replace(',00', '')
    }
    return `COP${finalPrice}`

  }

  useEffect(() => {
    updateOpenModal(false)
  },[triggerClose])

  /**
   * @INFO Cerrar el modal
   */
  const handleCloseModal = () => {
    updateTriggerClose({})
  }

  const trainingV2Body = () => {
    return (
      <>
        <div className="field-container">
          <OverlayTrigger placement='bottom' overlay={<Tooltip id='tooltip_icon_sidebar_editor' >{t('components.offer_card.course')}: {course.program?.name}</Tooltip>} >
            <div className={'field title'}>
              <span>{t('components.offer_card.course')}</span>: <span className='field-title-content'>{course.program?.name}</span>
            </div>
          </OverlayTrigger>
          {course?.custom_training?.price ? (
            <div className="field price">{parseFloat(course?.custom_training?.price).toLocaleString('es-CO', {style: 'currency', currency: 'COP'})}</div>
          ): null}
        </div>
        {course?.custom_training?.modality && (
          <div className="field modality">{course?.custom_training?.modality}</div>
        )}
        {course.extra_info?.description && (
          <div className={'description'}>
            <span className={'short-desc-mooc'}>
              {course.extra_info?.description}
            </span>
          </div>
        )}
      </>
    )
  }

  console.log({ course })

  return(
    <div
      className={`offer_card-component ${props.list ? 'list' : ''}`}
    >
      {(course.elementType === 'course' || course.elementType === 'moocs') && (
        <>
          <div className="offer-container" style={{position: 'relative'}}>
            {isFree && (
              <div style={{ position: 'absolute', left: '0px', top: '0px' }}>
                <FreeTag />
              </div>
            )}
            {props.link ? (
              <Link
                to={props.link}
              >
              <div className={'card-superior'} style={{backgroundImage: `url(${course?.extra_info?.coverUrl})`}}>
                <div className={'fecha'}></div>
                <div className={'cardd-foot'}></div>
              </div>
              </Link>
            ) : (
              <div className={'card-superior'} style={{backgroundImage: `url(${course?.extra_info?.coverUrl})`}}>
                <div className={'fecha'}></div>
                <div className={'cardd-foot'}></div>
              </div>
            )}
            <div className={'cardd-foot'}>
              <div className={'modalidad'}>{t('components.offer_card.subscribe')}</div>
              <div className={'social'}>
                <IconContext.Provider value={{ color: "#8dc8e8", className: "icon" }}>
                  <div>
                    <AiOutlineHeart/>
                  </div>
                </IconContext.Provider>
                <IconContext.Provider value={{ color: "#8dc8e8", className: "icon" }}>
                {props.share && (
                  <div className="dropdown">
                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <MdShare/>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                        <>
                          <FacebookShareButton url={props.share}>
                            <FaFacebookF size="1.3rem"/>
                          </FacebookShareButton>
                          <TwitterShareButton url={props.share}>
                            <FaTwitter size="1.3rem"/>
                          </TwitterShareButton>
                          <LinkedinShareButton url={props.share}>
                            <FaLinkedinIn size="1.3rem"/>
                          </LinkedinShareButton>
                          <EmailShareButton url={props.share}>
                            <MdEmail size="1.3rem"/>
                          </EmailShareButton>
                          <WhatsappShareButton url={props.share}>
                            <FaWhatsapp size="1.3rem"/>
                          </WhatsappShareButton>
                        </>
                    </div>
                  </div>
                )}
                </IconContext.Provider>
              </div>
            </div>
          </div>
          <div className={`card-body ${course.elementType}`}>
            <div className={'description'}>
              <span className={'nombre-curso'}>{course.program?.name}</span>
              {course?.extra_info?.is_alternative_title_active && (
                <span>{course?.extra_info?.alternative_title}</span>
              )}
            </div>
            <div className="body">
              <div className="body-left">
                {course.duration && (
                  <div className="field">
                    Duración: {durationFieldService.getDurationFormated(course.duration, 'large')}
                  </div>
                )}
                <div className="field modality">{course.schedulingMode?.name}</div>
                {!isFree && (
                  <div className="field start-date">{`${t('components.offer_card.start')}: ${course.startDate}`}</div>
                )}

                {!props.hidePrice && course.hasCost === true && course.priceCOP && !isFree ? (
                  <>
                    {course?.discount && course?.endDiscountDate && moment().isSameOrBefore(moment.utc(course?.endDiscountDate).endOf('day')) ?
                      <div className="container-discount">
                        <div className="discount-value-card">
                          {`${course?.discount}% Dcto *`}
                        </div>
                        <p>
                          {getPrice(false)}
                        </p>
                      </div>
                    :null}
                    <div className="field price">
                      <div style={{flex: 1}}>
                        Precio: {getPrice()}
                      </div>
                      <div>
                        {!props.hideInfoIcon ?
                          <AiOutlineInfoCircle color='#7C878E' />
                        :null}
                      </div>
                    </div>
                    {!props.hideValidUntil && course?.discount && course?.endDiscountDate && moment().isSameOrBefore(moment(course?.endDiscountDate).endOf('day')) ? (
                      <span className="small">*Válido hasta <b>{moment.utc(course?.endDiscountDate).format('DD/MM/YYYY')}</b>. No es acumulable con otras promociones</span>
                    ): null}
                    {!props.hideTaxesText ?
                      <div>
                        <span className="small">Estos valores corresponden a tarifas en pesos colombianos COP. Para la tarifa de su país por favor contáctese con la oficina de su ciudad.</span>
                      </div>
                    :null}
                  </>
                ): null}

              </div>
            </div>
          </div>
        </>
      )}
      {course.elementType === 'training' && (
        <>
          <div className={`offer-container ${course.elementType}`}>
            <div className={'card-superior'} style={{backgroundImage: `url(${course?.extra_info?.coverUrl})`}}>
              <div className={'fecha'}></div>
              <div className={'cardd-foot'}></div>
            </div>
            <div className={'cardd-foot'}>
              <div className={'modalidad'}>{t('components.offer_card.subscribe')}</div>
              <div className={'social'}>
                <IconContext.Provider value={{ color: "#8dc8e8", className: "icon" }}>
                  {props.share && (
                    <div className="dropdown">
                      <button className="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <MdShare/>
                      </button>
                      <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                        <FacebookShareButton url={props.share}>
                          <FaFacebookF size="1.3rem"/>
                        </FacebookShareButton>
                        <TwitterShareButton url={props.share}>
                          <FaTwitter size="1.3rem"/>
                        </TwitterShareButton>
                        <LinkedinShareButton url={props.share}>
                          <FaLinkedinIn size="1.3rem"/>
                        </LinkedinShareButton>
                        <EmailShareButton url={props.share}>
                          <MdEmail size="1.3rem"/>
                        </EmailShareButton>
                        <WhatsappShareButton url={props.share}>
                          <FaWhatsapp size="1.3rem"/>
                        </WhatsappShareButton>
                      </div>
                    </div>
                  )}
                </IconContext.Provider>
              </div>
            </div>
          </div>
          <div className={`card-body ${course.elementType}`}>
            <OverlayTrigger placement='bottom' overlay={<Tooltip id='tooltip_icon_sidebar_editor' >{t('components.offer_card.course')}: {course.program?.name}</Tooltip>} >
              <div className={'title'}>
                  {t('components.offer_card.course')}: {course.program?.name}
              </div>
            </OverlayTrigger>
            <div className={'description'}>
              <span className={'short-desc-mooc'}>
                {(course.extra_info?.description && course.extra_info?.description.length > 65)
                  ? `${course.extra_info?.description}`
                  : course.extra_info?.description
                }
              </span>
            </div>
            {course?.custom_training?.modality && (
              <div className="field modality">{course?.custom_training?.modality}</div>
            )}
            <div className="field-container">
              {course?.custom_training?.city && (
                <div className="field">{`Ciudad: ${course?.custom_training?.city}`}</div>
              )}
              {course?.startDate && (
                <div className="field start-date">{`Fecha: ${course.startDate}`}</div>
              )}
            </div>
          </div>
        </>
      )}
      {course.elementType === 'training_v2' && (
        <>
          <div className={`offer-container ${course.elementType}`}>
            <div
              className={`card-superior ${course.elementType}`}
              style={{
                backgroundImage: `url(${course?.extra_info?.coverUrl})`,
                cursor: course.custom_training?.video?.url && course.custom_training?.video?.platform ? 'pointer' : undefined
              }}
              onClick={(course.custom_training?.video?.url && course.custom_training?.video?.platform) ? () => updateOpenModal(true) : undefined}
            >
              <div className={'fecha'}></div>
              <div className={`cardd-foot`}></div>
            </div>
            <div className={`cardd-foot ${course.elementType}`}>
              <div className={'modalidad'}>

              </div>
              <div className={'social'}>
                <IconContext.Provider value={{ color: "#8dc8e8", className: "icon" }}>
                  {props.share && (
                    <div className="dropdown">
                      <button className="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <MdShare/>
                      </button>
                      <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                        <FacebookShareButton url={props.share}>
                          <FaFacebookF size="1.3rem"/>
                        </FacebookShareButton>
                        <TwitterShareButton url={props.share}>
                          <FaTwitter size="1.3rem"/>
                        </TwitterShareButton>
                        <LinkedinShareButton url={props.share}>
                          <FaLinkedinIn size="1.3rem"/>
                        </LinkedinShareButton>
                        <EmailShareButton url={props.share}>
                          <MdEmail size="1.3rem"/>
                        </EmailShareButton>
                        <WhatsappShareButton url={props.share}>
                          <FaWhatsapp size="1.3rem"/>
                        </WhatsappShareButton>
                      </div>
                    </div>
                  )}
                </IconContext.Provider>
              </div>
            </div>
            {course.custom_training?.video?.url && course.custom_training?.video?.platform && (
              <div
                className='video-float'
                onClick={() => updateOpenModal(true)}
              >
                <div className='video-float-container'>
                  <div className='video-float-background'></div>
                  <OverlayTrigger
                    placement='right'
                    overlay={<Tooltip id={`course_video_${course._id}`} >Ver video</Tooltip>} >
                    <BsPlay />
                  </OverlayTrigger>
                </div>
              </div>
            )}
          </div>
          <div className={`card-body ${course.elementType}`}>
            {props.link ? (
              <Link
                to={props.link}
              >
                {trainingV2Body()}
              </Link>
            ) : (
              <>
                {trainingV2Body()}
              </>
            )}
          </div>
          {
          course.custom_training?.video?.url &&
          course.custom_training?.video?.platform ?
            <ModalMediaComponent
              media={{
                name: course.program?.name || '',
                url: course.custom_training?.video?.url,
                // @ts-ignore
                type: course.custom_training?.video?.platform
              }}
              open={openModal}
              showDescription
              showName
              onClose={handleCloseModal}
            />
          :null}
        </>
      )}
		</div>
  )
}

export default OffercardCommonLayout
